<template>
  <div class="talent-container">
    <div v-if="is" class="no-data">
      <img src="@/assets/image/pending-search.png" alt="">
      <p>很抱歉！暂无相关内容</p>
    </div>
    <div v-else>
      <p class="title" v-html="title"></p>
      <div class="content-box" v-html="content">
      </div>
      <el-button class="btn" @click="dialogVisible = true">了 解 更 多</el-button>
    </div>
    <more-dialog
      ref="moreDialog"
      :dialog-visible="dialogVisible"
      @close="handleClose"
      @submit="submit"></more-dialog>
  </div>
</template>

<script>
import MoreDialog from './moreDialog.vue'
import { addMessageBoard } from '@/api/talentService'
export default {
  components: {
    MoreDialog
  },
  data() {
    return {
      title: '',
      content: '',
      dialogVisible: false,
      is: false
    }
  },
  methods: {
    handleClose() {
      this.dialogVisible = false
      this.$nextTick(() => {
        this.$refs.moreDialog.$refs.ruleForm.resetFields()
      })
    },
    init(info) {
      if (info.data) {
        this.title = info.data.title
        this.content = info.data.content
      } else {
        this.is = true
      }
      this.label = info.label
    },
    submit(data) {
      const form = {
        ...data,
        source: this.label
      }
      addMessageBoard(form).then(res => {
        const { code, message } = res
        if (code === 0) {
          this.dialogVisible = false
          this.$message.success('提交成功，我们会尽快回复您的申请～')
        } else {
          this.$message.error(message)
        }
      })
    }
  }
}
</script>

<style lang='scss'>
.talent-container {
  padding: 50px 63px;
  .title {
    // font-size: 36px;
    // font-weight: bold;
    // color: #145BC3;
    text-align: center;
  }
  .content-box {
    color: #333;
    margin-top: 22px;
    line-height: 1.6;
    font-size: 14px;
    img {
      max-width: 720px;
      text-align: center;
      display: block;
      margin: 40px auto;
    }
    p {
      img {
        max-width: 720px;
        text-align: center;
        display: block;
        margin: 40px auto;
      }
    }
  }
  .btn {
    width: 200px;
    height: 50px;
    border-radius: 25px;
    margin: 40px auto;
    display: block;
    color: #fff;
    font-size: 24px;
    background: linear-gradient(90deg, #0F59BE 0%, #496EEE 100%);
    box-shadow: 0px 1px 13px 0px rgba(0, 0, 0, 0.08);
  }

  .no-data {
    width: 304px;
    margin: 90px auto 0;
    text-align: center;
    img {
      margin-bottom: 30px;
    }
    p {
      color: #999;
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
    }
    .left {
      text-align: left;
      margin: 15px 40px;
    }
  }

}
</style>
